export default __webpack_public_path__ + "static/media/fruits.110e465c.jpg";